/**
 * Breadcrumb pathway capture.
 *
 * Records which collection a visitor was browsing when they clicked through to a product,
 * so the PDP breadcrumb can read HOME / NEW ARRIVALS / SEDA MINI DRESS - SKY instead of an
 * arbitrary collection. Read back by snippets/breadcrumbs.liquid.
 *
 * Only fires inside a genuine collection context — a container carrying
 * data-breadcrumb-collection-url. Search results, blog posts, related-product blocks and
 * cart upsells deliberately carry no such attribute, so those arrivals fall through to the
 * server-rendered category / Shop All fallback.
 *
 * sessionStorage, keyed by product handle: it survives back/forward within the tab and can
 * never attach a stale collection to a different product.
 */
(function () {
  var KEY = 'twg:breadcrumb';

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var link = target.closest('a[href*="/products/"]');
      if (!link) return;

      var source = link.closest('[data-breadcrumb-collection-url]');
      if (!source) return;

      var handle = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!handle) return;

      var title = source.getAttribute('data-breadcrumb-collection-title');
      var url = source.getAttribute('data-breadcrumb-collection-url');
      if (!title || !url) return;

      try {
        sessionStorage.setItem(
          KEY,
          JSON.stringify({
            product: decodeURIComponent(handle[1]),
            title: title,
            url: url,
          })
        );
      } catch (e) {
        /* private browsing / storage full — breadcrumb falls back to the server default */
      }
    },
    true
  );
})();
